import { UiTheme } from '../../theme'

export default (theme: UiTheme) => ({
  wrapper: {
    base: {
      position: 'relative',
      display: 'inline-block',
      width: '100%',
      paddingBottom: '5px',
    },

    flush: {
      paddingBottom: 0,
    },
  },

  select: {
    base: {
      ...theme.typography.body,
      position: 'relative',
      borderRadius: theme.settings.borderRadiuses.regular,
      outline: 'none',
      // small padding + 25px to compensate for icon's visual left
      paddingRight: `${parseInt(theme.settings.spacing.small, 10) + 25}px`,
      paddingLeft: theme.settings.spacing.medium,
      width: '100%',
      height: '40px',
      color: '#404e59',
      fontWeight: 600,
      cursor: 'pointer',
      transition: `border ${theme.settings.transitions.regularFast}`,
      ...theme.settings.focusStyles,
    },
    normal: {
      backgroundColor: 'white',
      border: theme.settings.borders.regular,
      ':hover': {
        backgroundColor: '#f7f9fb',
      },
    },
    active: {
      border: theme.settings.borders.primary,
    },
    disabled: {
      backgroundColor: 'rgba(204, 204, 204, 0.1)',
      border: theme.settings.borders.regular,
      cursor: 'default',
    },
    focused: {
      ...theme.settings.focus,
    },
  },

  selectLabel: {
    base: {
      display: 'block',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      lineHeight: '18px',
    },
    disabled: {
      opacity: 0.5,
    },
    withLabel: {
      color: theme.colors.accents.primary,
    },
  },

  selectList: {
    base: {
      position: 'absolute',
      top: '45px',
      left: 0,
      minWidth: '220px',
      backgroundColor: 'white',
      borderRadius: theme.settings.borderRadiuses.regular,
      boxShadow: theme.settings.shadows.elevation[1],
      border: theme.settings.borders.regular,
      padding: 0,
      listStyle: 'none',
      overflow: 'auto',
      maxHeight: '320px',
      zIndex: 1,
    },
  },

  nativeSelect: {
    base: {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      opacity: 0,
      cursor: 'pointer',
      WebkitAppearance: 'none',
    },
    disabled: {
      cursor: 'default',
    },
  },

  option: {
    base: {
      position: 'relative',
      display: 'flex',
      alignItems: 'center',
      width: '100%',
      backgroundColor: 'white',
      color: '#404e59',
      ...theme.typography.body,
      fontWeight: 600,
    },
    normal: {
      ':hover': {
        backgroundColor: '#f7f9fb',
      },
    },
    selected: {
      color: '#298bff',
    },
    disabled: {
      color: 'rgba(64, 78, 89, 0.5)',
      cursor: 'default',
    },
  },

  optionLabel: {
    base: {
      display: 'flex',
      alignItems: 'center',
      width: '100%',
      paddingTop: theme.settings.spacing.small,
      paddingRight: theme.settings.spacing.medium,
      paddingBottom: theme.settings.spacing.small,
      paddingLeft: theme.settings.spacing.medium,
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      cursor: 'pointer',

      '.intent-mouse &:focus': {
        outline: 'none',
      },

      ':focus': {
        outlineOffset: '-5px',
      },
    },
  },

  chevronIcon: {
    base: {
      position: 'absolute',
      right: '10px',
      height: '100%',
    },
    active: {
      transform: 'rotateZ(-180deg)',
    },
    svg: {
      marginTop: '-1px',
    },
  },

  checkmarkIcon: {
    base: {
      width: '20px',
      height: '20px',
      display: 'inline-block',
      color: '#298bff',
      marginRight: theme.settings.spacing.small,
    },
  },
})
